import {
    convertCurrencyFormatPositiveNegative,
    convertPersianDateToUniversalDate, convertUniversalDateTimeToPersianDateTime,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoDatePicker,
    RaikoGridFourColumn,
    showSuccessMessage,RaikoErrorSection,
    RaikoGridOneColumn, RaikoMoneyInputOutlined, RaikoTableTitleContainer, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useAuthState} from "../../../context/AuthContext";
import {useParams} from "react-router-dom";
import {LoanRequestsService} from "../../../serverService/loanRequests/LoanRequestsService";
import React, {useEffect, useState} from "react";
import {LoanService} from "../../../serverService/loan/LoanService";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {useDebounce} from "@uidotdev/usehooks";
import {numberIsEmpty, stringIsEmpty} from "../../../util/VariableChecker";
import {Skeleton} from "@mui/material";
import RaikoCardInfoTypeOne, {
    RaikoCardInfoTypeOneItemGenerator
} from "../../../raikoComponents/raikoCardInfo/RaikoCardInfoTypeOne";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function LoanRequestDetailSubmit(
    {
        loanDefaultAmount,
        loanDefaultInstallments,
        accountId,
        handleCreateLoan
    }) {

    const {fundID} = useAuthState()
    const {id: loanRequestId} = useParams()

    const service = new LoanRequestsService()
    const loanService = new LoanService()

    const [loanKinds, setLoanKinds] = useState([]);

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        getLoanKinds()
    }, [fundID]);

    function getLoanKinds() {
        loanService.getLoanKinds()
            .then(response => {
                setLoanKinds([])
                response.map((item, index) => {
                    setLoanKinds(prev => [
                        ...prev,
                        raikoCustomSelectItemGenerator(item.id, item.persianName)
                    ])
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        })
    }

    const [selectedLoanType, setSelectedLoanType] = useState("")
    const [loanAmount, setLoanAmount] = useState(loanDefaultAmount);
    const [payDate, setPayDate] = useState("");
    const [installmentAmounts, setInstallmentAmounts] = useState(loanDefaultInstallments);

    const filterSelectedLoanType = useDebounce(selectedLoanType, 300)
    const filterLoanAmount = useDebounce(loanAmount, 500)
    const filterLoanPayDate = useDebounce(payDate, 500)
    const filterInstallmentAmounts = useDebounce(installmentAmounts, 500)

    const [installments, setInstallments] = useState([]);
    const [installmentsLoading, setInstallmentsLoading] = useState(false)

    useEffect(() => {
        if (
            filterSelectedLoanType.toString().length > 0 &&
            !numberIsEmpty(filterLoanAmount) &&
            !numberIsEmpty(filterInstallmentAmounts) &&
            !stringIsEmpty(filterLoanPayDate)
        ) {
            calculateLoanInstallments()
        } else
            setInstallments([])
    }, [
        filterSelectedLoanType,
        filterLoanAmount,
        filterLoanPayDate,
        filterInstallmentAmounts
    ]);

    function calculateLoanInstallments() {
        setInstallmentsLoading(true)
        loanService.calculateLoanInstallments(
            fundID,
            accountId,
            filterLoanAmount,
            filterInstallmentAmounts,
            filterSelectedLoanType,
            convertPersianDateToUniversalDate(filterLoanPayDate)
        )
            .then(response => {
                setInstallments(response.installments)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setInstallmentsLoading(false)
        })
    }

    function handleCreateNewLoan() {
        loading.show()
        service.acceptLoanRequest(
            fundID,
            loanRequestId,
            selectedLoanType,
            loanAmount,
            installmentAmounts,
            convertPersianDateToUniversalDate(payDate)
        ).then(response => {
            showSuccessMessage("وام جدید با موفقیت ساخته شد.")
            handleCreateLoan()
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoTableTitleContainer
                title={"اطلاعات وام"}
                hasCreateNewItem={installments && installments.length > 0}
                createNewItemTitle={"ثبت وام"}
                handleCreateNewItem={handleCreateNewLoan}

            />
            <RaikoGridFourColumn>
                <RaikoCustomSelect
                    labelText={"نوع وام"}
                    value={selectedLoanType}
                    setValue={setSelectedLoanType}
                    items={loanKinds}
                />
                <RaikoMoneyInputOutlined
                    labelText={"مبلغ وام (ریال)"}
                    value={loanAmount}
                    setValue={setLoanAmount}
                />

                <RaikoDatePicker
                    label={"تاریخ پرداخت"}
                    date={payDate}
                    setDate={setPayDate}/>

                <RaikoMoneyInputOutlined
                    labelText={"تعداد اقساط"}
                    value={installmentAmounts}
                    setValue={setInstallmentAmounts}
                />

            </RaikoGridFourColumn>

            <RaikoTableTitleContainer
                title={"پیش نمایش اقساط"}
                amount={installments.length}
            />

            <RaikoGridOneColumn>
                {
                    installmentsLoading ?
                        [...Array(3)].map((item) => {
                            return <Skeleton
                                key={item}
                                variant="rectangular"
                                className={css`padding: 100px 100px`}
                            />
                        })
                        : installments && installments.length > 0 ?
                            installments.map((item, index) => {
                                return <RaikoCardInfoTypeOne
                                    title={convertUniversalDateTimeToPersianDateTime(item.date)}
                                    titleLabel={"سررسید"}
                                    items={[
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ قسط (ریال)", convertCurrencyFormatPositiveNegative(item.amount)),
                                        RaikoCardInfoTypeOneItemGenerator("کارمزد (ریال)", convertCurrencyFormatPositiveNegative(item.amountOfCommission)),
                                        RaikoCardInfoTypeOneItemGenerator("مبلغ کمکی (ریال)", convertCurrencyFormatPositiveNegative(item.auxiliaryAmount)),
                                        RaikoCardInfoTypeOneItemGenerator("قابل پرداخت (ریال)", convertCurrencyFormatPositiveNegative(item.payableAmount)),
                                    ]}
                                />
                            }) :
                            <RaikoErrorSection
                                title={"برای نمایش اقساط ابتدا مشخصات فوق را وارد نمایید."}
                            />
                }
            </RaikoGridOneColumn>
        </RaikoGridOneColumn>
    )
}
